import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';

import { ManagePermissions } from '../manage-permissions/ManagePermissions';

type ManagePermissionsModalProps = {
  nodeId: string;
  nodeTitle: string;
  open: boolean;
  onClose: () => void;
};

export default function ManagePermissionsModal({ open, onClose, nodeId, nodeTitle }: ManagePermissionsModalProps) {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-80"
          leave="ease-in duration-200"
          leaveFrom="opacity-80"
          leaveTo="opacity-0"
        >
          <div aria-hidden className="fixed inset-0 bg-black opacity-80" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-hidden">
          <div className="flex max-h-screen items-center justify-center p-4 text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel
                className="flex relative w-full max-w-min h-5/6 transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all"
                style={{ maxHeight: '85vh' }}
              >
                <ManagePermissions nodeId={nodeId} title={nodeTitle} />
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
